export const EVENTS_NAME = {
	publish: "publish",
	unpublish: "unpublish",
};

export const ZENDESK_TYPES_NAME = {
	series: "Video Series",
	guides: "Guides",
};

export const ZENDESK_SOURCES_NAME = {
	series: "Video Series",
	guides: "Guides",
};

export const ZENDESK_TYPES = {
	series: "series",
	guides: "guides",
};

export const CONTENTFUL_ZENDESK_TYPES = {
	pageVideoSeries: "series",
	pageGuide: "guides",
};

export const contentfulDefaultLocale = "en-US";

export const defaultLocale = "en-us";

export const pagePaths = {
	pageVideoSeries: "/series",
	pageGuide: "/guides",
};

export const getRecordUrl = ({ domain, path, slug }) => `https://${domain}${path}/${slug}`;

export const getAuthHeader = (email, token) =>
	Buffer.from(`${email}/token:${token}`).toString("base64");

export const transformRecord = record => {
	// eslint-disable-next-line camelcase
	const { title, body, external_id, locale, url, type, source } = record;

	return {
		title,
		body,
		external_id,
		locale,
		url,
		source_id: source.id,
		type_id: type.id,
	};
};
